import React, { useState, useRef, useEffect } from "react";
import style from "./variantCard.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import EditInput from "../../EditInput/input"
import RadioButton from "../../EditRadioButton/RadioButton"
import Hint from "../variantCardHint/variantCardHint"
import Skeleton from "../../skeleton/skeleton"
import { getManyVariant, GetChannelDefaultSetting } from '../../../actions/APIcalls'
import { Link } from "react-router-dom";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas";

const VariantCard = (props) => {

    const [prevState, setPrevState] = useState({
        purchasePrice: props.data.robot && props.data.robot.purchasePrice ? props.data.robot.purchasePrice : '',
        minimumProfitMarginType: props.data.robot && props.data.robot.minimumProfitMarginType ? props.data.robot.minimumProfitMarginType : '',
        minimumProfitMargin: props.data.robot && props.data.robot.minimumProfitMargin ? props.data.robot.minimumProfitMargin : '',
        emptyMinimumProfitMarginError: false,
    })
    const [inputChange, setInputChange] = useState({
        typing: false,
        typingTimeout: null,
    })

    const nameRef = useRef(null);
    const hintRef = useRef(null);

    const [editInfo, setEditInfo] = useState({ ...prevState })

    const [showMinMaxPrice, setShowMinMaxPrice] = useState({
        minPrice: '',
        maxPrice: '',
        minMaxPriceLoading: false,
    })
    const [isEdited, setIsEdited] = useState(false)
    const [showHint, setShowHint] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    useEffect(() => {
        if (isEdited) {
            props.isEditing('add')
        } else {
            props.isEditing('remove')
        }
    }, [isEdited]);

    const handleClickOutside = event => {
        if ((hintRef.current && !hintRef.current.contains(event.target) && !event.target.className.includes('variantCard_linkText')) || event.target.className.includes('variantCard_hideHint')) {
            setShowHint(false);
        }
    };

    const handleRadioButton = (e, value, tag, secondTag) => {
        let tmp = editInfo
        editInfo.minimumProfitMarginType = tag
        setEditInfo({ ...tmp })
        setIsEdited(true)

        // calculate minimum & maximum price
        if (editInfo.purchasePrice && editInfo.minimumProfitMargin && editInfo.minimumProfitMarginType) {
            // debouncer 
            if (inputChange.typingTimeout) {
                clearTimeout(inputChange.typingTimeout);
            }
            setInputChange({
                ...inputChange,
                typing: false,
                typingTimeout: setTimeout(function () {
                    editFunction('calculatePrice')
                }, 300),
            })
        }
    }

    const handleEditInfo = (tag, item) => {
        let tmp = editInfo
        tmp[tag] = toEnglishNumber(item.target.value).replaceAll(',', '')
        setEditInfo({ ...tmp })
        setIsEdited(true)

        // calculate minimum & maximum price
        if (editInfo.purchasePrice && editInfo.minimumProfitMargin && editInfo.minimumProfitMarginType) {
            // debouncer 
            if (inputChange.typingTimeout) {
                clearTimeout(inputChange.typingTimeout);
            }
            setInputChange({
                ...inputChange,
                typing: false,
                typingTimeout: setTimeout(function () {
                    editFunction('calculatePrice')
                }, 300),
            })
        }
    }

    const calculateLines = text => {
        if (text.length < 110) {
            return text
        } else {
            return text.substr(0, 90) + '...'
        }
    }

    const calculateActivition = (isActive) => {
        if (isActive) {
            return 'فعال'
        } else {
            return 'غیرفعال'
        }
    }

    const defineMinPriceTypeText = type => {
        let res;
        switch (type) {
            case 'percent':
                res = 'مقدار درصد'
                break;
            case 'price':
                res = 'مقدار مبلغ'
                break;
            case 'minPrice':
                res = 'حداقل حاشیه سود'
                break;
            default:
                res = 'مقدار حاشیه سود'
                break;
        }
        return res
    }

    const saveCodeToClipboard = code => {
        if (code) {
            navigator.clipboard.writeText(code)
            alert('کد مورد نظر شما کپی شد')
        }
    }

    const resetAllEditInfo = () => {
        let tmp = editInfo
        tmp = { ...prevState }
        setEditInfo({ ...tmp })

        let tmpShowMinMaxPrice = showMinMaxPrice
        tmpShowMinMaxPrice.maxPrice = ''
        tmpShowMinMaxPrice.minPrice = ''
        tmpShowMinMaxPrice.minMaxPriceLoading = false
        setShowMinMaxPrice({ ...tmpShowMinMaxPrice })
        setIsEdited(false)
    }

    const setAllEditInfo = () => {
        // call to change
        if ((editInfo.minimumProfitMargin != '' && typeof editInfo.minimumProfitMargin != 'undefined') && (editInfo.purchasePrice != '' && typeof editInfo.purchasePrice != 'undefined')) {
            editFunction('editInfo')
            setIsEdited(false)
        } else {
            let tmp = editInfo
            tmp.emptyMinimumProfitMarginError = true
            setEditInfo({ ...tmp })
        }
    }

    const editFunction = async (type) => {
        let data = props.data.robot ? props.data.robot : { purchasePrice: null, minimumProfitMarginType: null, minimumProfitMargin: null, variantId: null }
        data.purchasePrice = editInfo.purchasePrice
        data.minimumProfitMarginType = editInfo.minimumProfitMarginType
        data.minimumProfitMargin = editInfo.minimumProfitMargin
        data.variantId = props.data._id

        // get commission
        let commission = await getManyVariant([props.data.productGroup])
        data.DKCommission = commission.data.maxinCommission ? commission.data.maxinCommission : commission.data.minCommission

        //if doesn't have robot calculate robot properties
        if (!props.data.robot) {
            let defaultData = {
                ancillaryCosts: "0", changePricePromotion: "false", maximumProfitMargin: "1000", maximumProfitMarginType: "percent",
                priceIncrease: "free", pricingStrategy: "aiSmart", promotionMinPrice: "", reactivation: "enable", salesStatus: true, hasMaxPriceLimit: false,
                sizeOfPriceIncrease: "1000", hasIncreasePricePermission: false, safePricing: true, outOfRangeStrategy: "off", roundnessDigits: 2, platformCosts: false
            }
            let setting = await GetChannelDefaultSetting({ channel_id: props.data.channel._id })
            if (typeof setting !== "undefined" && typeof setting.data !== "undefined" && setting.data.data) {
                defaultData = setting.data.data
                if (typeof setting.data.data.hasMaxPriceLimit == 'undefined') {
                    defaultData.hasMaxPriceLimit = false
                    defaultData.platformCosts = false
                }
            }
            data = { ...defaultData, ...data }
        }

        let calculatedRes;
        if (type == 'editInfo') {
            // set loading to true
            setIsUpdating(true)
            calculatedRes = await props.SubmitEdit(data)
            // remove minmaxPrice
            let tmpShowMinMaxPrice = showMinMaxPrice
            tmpShowMinMaxPrice.maxPrice = ''
            tmpShowMinMaxPrice.minPrice = ''
            tmpShowMinMaxPrice.minMaxPriceLoading = false
            setShowMinMaxPrice({ ...tmpShowMinMaxPrice })
            // set loading to false
            setIsUpdating(false)
        }
        if (type == 'calculatePrice') {
            let tmpShow = showMinMaxPrice;
            setShowMinMaxPrice({ ...tmpShow, minMaxPriceLoading: true })
            calculatedRes = await props.CalculateEdit(data)
            if (calculatedRes && calculatedRes.data) {
                tmpShow.minPrice = calculatedRes.data.price.data.minProfit.sellPrice
                tmpShow.maxPrice = calculatedRes.data.price.data.maxProfit.sellPrice
            }
            setShowMinMaxPrice({ ...tmpShow, minMaxPriceLoading: false })
        }
    }

    if (isUpdating) {
        return <Skeleton type='rectangle' width='100%' height='176px' />
    }
    else {
        return (
            <div style={props.disabled ? { opacity: "0.40" } : {}} className={style.container}>
                {props.disabled && <div className={style.disabledContainer}></div>}
                <div className={props.isGroup ? style.WrapperWithoutRadius : style.wrapper}
                    style={{ backgroundColor: props.data.robot && props.data.robot !== null ? "#f8faff" : "#fdf1f1", borderRadius: props.data.robot && props.data.robot !== null ? '8px' : '8px 8px 0px 0px' }}
                >
                    {
                        props.data.robot === null ?
                            <div className={style.newProductLineRed}></div>
                            :
                            <div className={style.newProductLineGreen}></div>
                    }

                    {/* new Version */}
                    <div className={style.newFlexWrapper}>
                        <div className={style.flexItem303}>
                            <div className={style.nameStyle}>
                                <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }} target="_blank">
                                    <div className={style.nameWrapper}>
                                        <p
                                            className={style.realName}
                                            data-content={!props.data.newName.split(' | ')[1].includes('گارانتی')
                                                &&
                                                !props.data.newName.split(' | ')[1].includes('تضمین')
                                                ?
                                                '(' + toPersianNumber(props.data.newName.split(' | ')[1]) + ')'
                                                :
                                                ''
                                            }
                                            ref={nameRef}
                                        >
                                            {toPersianNumber(props.number)}. {calculateLines(toPersianNumber(props.data.newName))}
                                            {/* {toPersianNumber(props.data.newName.split(' | ')[0])} {toPersianNumber(props.data.newName)} */}
                                        </p>

                                    </div>
                                </Link>
                            </div>
                            <div className={style.DKPStyle}>
                                <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.DKPC)}>
                                    <p className={style.codeNumber}>DKPC - {toPersianNumber(props.data.DKPC)}</p>
                                    <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>
                                </div>
                                <p className={style.DKPSeprator}></p>
                                <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.DKP)}>
                                    <p className={style.codeNumber}>DKP - {toPersianNumber(props.data.DKP)}</p>
                                    <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>
                                </div>

                                {props.data && props.data.supplierCode ? <>
                                    <p className={style.DKPSeprator}></p>
                                    <div className={style.clipboard} onClick={() => saveCodeToClipboard(props.data.supplierCode)}>
                                        <p className={style.codeNumber}>{props.data.supplierCode ? toPersianNumber(props.data.supplierCode) : '--'}</p>
                                        {props.data.supplierCode && <div className={style.tooltip}>برای کپی کردن کد کلیک کنید</div>}
                                    </div>
                                </> : null}

                                {props.data && props.data.otherSellerCount ? <>
                                    <p className={style.DKPSeprator}></p>
                                    <p className={style.codeNumber}>تعداد رقیب: {toPersianNumber(props.data.otherSellerCount)}</p>
                                </> : null}

                            </div>
                            {props.data && props.data.channel && props.channelList && props.channelList.length > 1 ? <p className={style.promotionText}>{props.data.channel.name}{typeof props.data.channel._id != 'undefined' && props.data.channel._id == "66c7067044e53ffa53755c93" ? ' ۲ ' : ''}</p> : <p> </p>}
                        </div>
                        <div className={style.flexItem51}>
                            {calculateActivition(props.data.salesStatus)}
                        </div>
                        <div className={style.flexItem124}>
                            <EditInput
                                value={editInfo.purchasePrice}
                                type="text"
                                disabled={false}
                                label=""
                                placeholder="قیمت خرید"
                                tag="purchasePrice"
                                error={(editInfo.purchasePrice == '' || typeof editInfo.purchasePrice == 'undefined') && editInfo.emptyMinimumProfitMarginError ? '! قیمت خرید را وارد کنید' : ''}
                                tooltip=''
                                onchange={(e, tag) => handleEditInfo(e, tag)}
                                onblur={() => console.log('')}
                            />
                        </div>

                        <div className={style.flexItem347}>
                            <RadioButton
                                value={editInfo.minimumProfitMarginType == 'percent' ? true : false}
                                tag='percent'
                                secondTag={props.data._id + '_percent'}
                                label='درصد'
                                onclick={handleRadioButton}
                                keys={props.data._id + '_percent'}
                            />
                            <RadioButton
                                value={editInfo.minimumProfitMarginType == 'price' ? true : false}
                                tag='price'
                                secondTag={props.data._id + '_price'}
                                label='مبلغ'
                                onclick={handleRadioButton}
                                keys={props.data._id + '_price'}
                            />
                            <RadioButton
                                value={editInfo.minimumProfitMarginType == 'minPrice' ? true : false}
                                tag='minPrice'
                                secondTag={props.data._id + '_minPrice'}
                                label='قیمت نهایی'
                                onclick={handleRadioButton}
                                keys={props.data._id + '_minPrice'}
                            />
                            <div style={{ width: '124px', marginRight: '16px' }}>
                                <EditInput
                                    value={editInfo.minimumProfitMargin}
                                    type="text"
                                    disabled={editInfo.minimumProfitMarginType == '' ? true : false}
                                    label=""
                                    placeholder={defineMinPriceTypeText(editInfo.minimumProfitMarginType)}
                                    tag="minimumProfitMargin"
                                    error=''
                                    tooltip=''
                                    onchange={(e, tag) => handleEditInfo(e, tag)}
                                    onblur={() => console.log('')}
                                />
                            </div>

                        </div>

                        <div className={style.flexItem32}>
                            {/* Check Mark */}
                            {isEdited && <div
                                className={style.editCheckMark}
                                onClick={() => setAllEditInfo()}
                            >
                                <div className={style.editCheckMarkImage}></div>
                            </div>}
                            {/* Cross Mark */}
                            {isEdited && <div
                                className={style.editCrossMark}
                                onClick={() => resetAllEditInfo()}
                            >e</div>}
                        </div>
                    </div>
                    {/* new Version */}

                    <button
                        className={style.proEditButton}
                        onClick={() => { props.threeDotHandler("edit", "one", props.data._id) }}
                    >
                        تنظیمات پیشرفته
                    </button>

                    {editInfo.minimumProfitMargin !== '' && !editInfo.emptyMinimumProfitMarginError ?
                        <div className={style.infoGrayBox}>
                            {showMinMaxPrice.minPrice && <div className={style.minMaxPriceText}>حداقل قیمت: {showMinMaxPrice.minMaxPriceLoading ? <div className={style.loading}><span>.</span><span>.</span><span>.</span></div> : toPersianNumber(numberWithCommas(showMinMaxPrice.minPrice))} <span className={style.rial}>ریال</span></div>}
                            {showMinMaxPrice.maxPrice && <div className={style.minMaxPriceText}>حداکثر قیمت: {showMinMaxPrice.minMaxPriceLoading ? <div className={style.loading}><span>.</span><span>.</span><span>.</span></div> : toPersianNumber(numberWithCommas(showMinMaxPrice.maxPrice))} <span className={style.rial}>ریال</span></div>}
                        </div>
                        :
                        null
                    }

                    {(editInfo.minimumProfitMargin == '' || typeof editInfo.minimumProfitMargin == 'undefined') && editInfo.emptyMinimumProfitMarginError ? <div className={style.infoRedBox}>
                        <p className={style.minimumProfitMarginError}>! حداقل حاشیه سود را وارد کنید</p>
                    </div> : null
                    }

                </div>

                {
                    props.data.robot === null &&
                    <div className={style.information}>
                        <p className={style.errorText}>.برای فعال‌سازی کالا در ربات، قیمت خرید و حداقل حاشیه سود را تکمیل کنید<span>h</span></p>
                        <div
                            className={style.tooltip}
                            onClick={() => setShowHint(true)}
                        >
                            <p className={style.linkText}>راهنما</p>
                            <div ref={hintRef}>
                                {showHint && <div className={style.left}>
                                    <div className={style.hideHint}>e</div>
                                    <Hint />
                                    <i></i>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div >
        )
    }
}

export default VariantCard;